import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Customer } from '../models/customer';
import { CustomerProfile } from '../models/customer-profile';
import { CustomerSearchResult } from '../models/customer-search-result';
import { TaskSearchResult } from '../models/task-search-result';
import { TaskSmall } from '../models/task-small';
import { Sow } from '../models/sow';

@Injectable({
  providedIn: 'root'
})
export class SowApiService {

  private apiBaseUrl = `${environment.apiUrl}sow`;

  constructor(private httpClient: HttpClient) { }

  public createSow(sow: Sow) {
    return this.httpClient.post<Sow>(`${this.apiBaseUrl}/createSow`, sow);
  }

  public updateSow(sow: Sow) {
    return this.httpClient.patch<Sow>(`${this.apiBaseUrl}/updateSow`, sow);
  }

   public getAllSowByContractId(contractId: number) {
    return this.httpClient.get<Sow[]>(`${this.apiBaseUrl}/getAllSowByContractId/${contractId}`)
  }

   public deleteSow(sowId: number) {
    return this.httpClient.delete<number>(`${this.apiBaseUrl}/deleteSow/${sowId}`);
  }

}
